import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { ModalPortal } from "../../../components/ModalPortal/ModalPortal";
import { CircularProgress } from "../../../components/CircularProgress/CircularProgress";
import { fetchCategoryList, type Category } from "../../../api/category";
import { useCurrentUserInfo } from "../../../hooks/useCurrentUserInfo";
import type { CheckTypeKey } from "../../../api/pricelist";
import { resolveTariffCheckLabels } from "../../../utils/resolveTariffChecks";
import type { CheckDetailKind } from "../checkDetailKind";

const KIND_TO_TYPE: Record<CheckDetailKind, CheckTypeKey> = {
  site: "siteCheck",
  it: "it",
};

export interface RequestDetailChecksModalProps {
  kind?: CheckDetailKind;
  handleCloseChecksModal: () => void;
}

export const RequestDetailChecksModal: React.FC<RequestDetailChecksModalProps> = ({
  kind = "site",
  handleCloseChecksModal,
}) => {
  const { userLimits } = useCurrentUserInfo();
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchCategoryList()
      .then((items) => {
        if (!cancelled) setCategories(items);
      })
      .catch(() => {
        if (!cancelled) {
          setCategories([]);
          setError("Не удалось загрузить список проверок");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const labels = resolveTariffCheckLabels(userLimits, KIND_TO_TYPE[kind], categories);

  return (
    <ModalPortal>
      <div className="detail-checks-modal-overlay" onClick={handleCloseChecksModal}>
        <div className="detail-checks-modal" onClick={(e) => e.stopPropagation()}>
          <div className="detail-checks-modal-head">
            <h3>Проверки в системе</h3>
            <button
              type="button"
              className="detail-tasklist-close"
              onClick={handleCloseChecksModal}
              aria-label="Закрыть список проверок"
            >
              <X size={18} />
            </button>
          </div>
          <div className="detail-checks-modal-list">
            {loading ? (
              <div className="detail-checks-modal-item">
                <CircularProgress size="sm" />
              </div>
            ) : error ? (
              <div className="detail-checks-modal-item">{error}</div>
            ) : labels.length === 0 ? (
              <div className="detail-checks-modal-item">Нет доступных проверок по тарифу</div>
            ) : (
              labels.map((label) => (
                <div key={label} className="detail-checks-modal-item">
                  {label}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};
